import { combineReducers } from 'redux';
import refundInformationSlice from './refundInformationSlice';
import productCatalogSlice from './productCatalogsSlice';
import endosoPolizaSlice from './endosoPolizaSlice';
import verifyCodeSlice from './verifyCodeSlice';

export default combineReducers({
    refundInformation   : refundInformationSlice,
    productCatalog      : productCatalogSlice,
    endosoPoliza        : endosoPolizaSlice,
    verifyCode          : verifyCodeSlice
});